import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CommunicationsProvider } from '@/context/CommunicationsContext';
import { RequireAuth } from '@/components/auth/RequireAuth';
import { SecureLayout } from '@/components/layout/SecureLayout';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { InboxPage } from '@/pages/InboxPage';
import { EmailDetailPage } from '@/pages/EmailDetailPage';
function ProtectedShell() {
    return (_jsx(CommunicationsProvider, { children: _jsx(SecureLayout, {}) }));
}
/**
 * HashRouter (same as Smart Repay) — Hostinger refresh never 404s because
 * routes live in the hash (#/login) and the server always serves index.html.
 */
export default function App() {
    return (_jsx(HashRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsx(Route, { element: _jsx(RequireAuth, {}), children: _jsxs(Route, { element: _jsx(ProtectedShell, {}), children: [_jsx(Route, { path: "/", element: _jsx(DashboardPage, {}) }), _jsx(Route, { path: "/inbox", element: _jsx(InboxPage, {}) }), _jsx(Route, { path: "/inbox/:messageId", element: _jsx(EmailDetailPage, {}) })] }) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }) }));
}
